<div class="page-container">
  <div class="main-page-title">
    @if (
      userService.getUser() !== null && userService.getUser() !== undefined
    ) {
      <span class="font-medium-headline-large">
        Willkommen {{ userService.getUser().firstname }} 👋
      </span>
    } @else {
      <span class="font-medium-headline-large"> Willkommen </span>
    }
  </div>
  <div>
    <app-news-banner-slider
      [newsBannerSlides]="newsBannerSlides"
      [isLoading]="newsBannersLoading"
      [showButtons]="false"></app-news-banner-slider>
  </div>
  <div class="card-slider-with-title">
    <div class="page-title">
      <span class="title-content">
        <i class="fa-regular fa-book-bookmark font-medium-display-small"></i>
        <span class="font-medium-display-small"> Alle Fortbildungen </span>
      </span>
    </div>
    <div class="card-slider-container">
      <app-card-slider
        (cardClicked)="onCardClicked($event)"
        [slides]="cardSlides"
        [isLoading]="seminarCategoriesLoading"></app-card-slider>
    </div>
  </div>

  @if (userService.getUser() !== null && userService.getUser() !== undefined) {
    <div class="my-next-seminars">
      <div class="page-title">
        <span class="title-content">
          <i class="fa-regular fa-calendar font-medium-display-small"></i>
          <span class="font-medium-display-small">
            Meine nächsten Termine
          </span>
        </span>
      </div>

      <div class="next-seminars">
        <div class="seminar-container hide-subsequent-rows">
          @if (seminarCardsLoading) {
            @for (item of seminarCardSkeletons; track $index) {
              <p-skeleton borderRadius="8px" height="100%" width="328px" />
            }
          } @else {
            @if (!displayedCards || displayedCards.length === 0) {
              <div class="no-seminars">
                <span class="font-medium-body">
                  Noch keine Seminare gebucht.
                </span>
              </div>
            } @else {
              @for (
                seminarCard of displayedCards;
                track seminarCard;
                let index = $index
              ) {
                <app-seminar-card-element
                  (click)="onSeminarCardClicked(seminarCard)"
                  [seminarCard]="seminarCard"></app-seminar-card-element>
              }
            }
          }
        </div>

        @if (seminarCards.length > visibleSeminarCardsCount) {
          <div class="next-seminars-expander">
            <button
              class="inwi-icon-text-button-medium"
              (click)="showAllSeminarCards = !showAllSeminarCards">
              <div class="button-content">
                @if (showAllSeminarCards === false) {
                  <div class="button-text">Alle Meine Termine sehen</div>
                  <div class="button-icon">
                    <i class="fa-solid fa-chevron-down"></i>
                  </div>
                } @else {
                  <div class="button-text">
                    {{
                      visibleSeminarCardsCount === 1
                        ? 'Ersten Termin sehen'
                        : 'Erste ' + visibleSeminarCardsCount + ' Termine sehen'
                    }}
                  </div>
                  <div class="button-icon">
                    <i class="fa-solid fa-chevron-up"></i>
                  </div>
                }
              </div>
            </button>
          </div>
        }

        @if (hasUpcomingSeminars) {
          <div class="contract-revocation">
            <button
              type="button"
              class="inwi-text-button-large-secondary"
              (click)="openContractRevocationDialog()">
              <div class="button-content">
                <div class="button-text">Vertrag widerrufen</div>
              </div>
            </button>
          </div>
        }
      </div>
    </div>
  }
  <div class="all-seminars">
    <div class="page-title">Alle Seminare</div>

    <app-seminar-table
      [pageSize]="100"
      [pageSizeOptions]="[5, 10, 20, 50, 100, 200]"
      [dataSource$]="dataSource$"
      [isLoading]="seminarsLoading" />


    @if (showNewsletterSection) {
      <app-newsletter></app-newsletter>

      <div class="newsletter-info">
        <div class="newsletter-info-title">
          Warum solltest du unseren Newsletter abonnieren?
        </div>
        <div class="newsletter-info-description">
          <ul>
            <li>
              <span class="newsletter-info-description-bold">
                Exklusive Angebote:
              </span>
              Erfahre als Erste*r von unseren exklusiven Fortbildungsangeboten
              und sichere dir coole Rabatte.
            </li>
            <li>
              <span class="newsletter-info-description-bold">
                Neueste Forschung:
              </span>
              Hol dir die aktuellsten wissenschaftlichen Erkenntnisse und Studien
              zur evidenzbasierten Therapie direkt in dein Postfach.
            </li>
            <li>
              <span class="newsletter-info-description-bold">
                Expertenwissen:
              </span>
              Lass dich von den Profis inspirieren und erweitere dein Wissen
              kontinuierlich.
            </li>
          </ul>
        </div>
      </div>
    }
  </div>
</div>
